import styled from 'styled-components';

const Content = styled.div`
  width: 100%;
  height: 300px;
`;

export default Content;
